import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { ClientGroupRepositoryBase, ClientRepositoryBase } from '@skylab-shared/business';
export { ClientRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(ClientGroupRepositoryBase)
export class ClientGroupRepository {
    public constructor(
        http: Http,
        weaver: Weaver
    ) { }
}
